export const dashboardTranslations = {
  title: "Dashboard",
  subtitle: "Here's what's happening today",
  welcomeUser: "Welcome",

  // Greetings
  goodMorning: "Good morning",
  goodAfternoon: "Good afternoon",
  goodEvening: "Good evening",

  // Quick actions
  quickActions: "Quick Actions",
  newOrder: "New Order",
  newItem: "New Item",
  newCustomer: "New Customer",
  newInvoice: "New Invoice",

  // Quick action modules
  ordersModule: "Orders",
  productsModule: "Products",
  customersModule: "Customers",
  inventoryModule: "Inventory",
  allModules: "All",
  settings: "Settings",

  // Modules
  modules: "Modules",
  items: "Items",

  // Module descriptions
  productsDescription: "Manage your catalog and pricing",
  inventoryDescription: "Track stock and warehouses",
  customersDescription: "Manage customer relationships",
  ordersDescription: "Process sales and invoices",
  pointRewardsDescription: "Loyalty programs and rewards",
  settingsDescription: "Configure your workspace",

  // Stats
  totalCustomers: "Customers",
  totalItems: "Items",
  ordersToday: "Orders Today",
  pendingDeliveries: "To Deliver",
  lowStock: "Low Stock",
  pendingInvoices: "Pending Invoices",

  // Action required
  actionRequired: "Action Required",

  // Needs attention
  needsAttention: "Needs Attention",

  // Recent activity
  recentActivity: "Recent Activity",

  // News section
  news: "News",
  newFeature: "New Feature",
  siteCanvas: "Site Canvas",
  siteCanvasDescription: "Build stunning storefronts with our new drag-and-drop page builder. Create, customize, and publish in minutes.",
  trySiteCanvas: "Try Site Canvas",

  // Storefront card
  yourStorefront: "Your Storefront",
  openStorefront: "Open",
  copyUrl: "Copy URL",

  // Shortcuts (kept for backwards compatibility)
  shortcuts: "Shortcuts",
  customers: "Customers",
  orders: "Orders",
  stockEntry: "Stock Entry",

  // Setup state (Epic 02)
  setupSubtitle: "We're setting up your workspace",
  setupCardTitle: "Setting up your workspace",
  setupCardDescription: "The Zaviago team is preparing your system. We'll notify you when everything is ready.",
  setupContactEmail: "support@zaviago.com",

  // Onboarding state (Epic 03)
  onboardingSubtitle: "Your workspace is ready",
  onboardingGetStarted: "Get started",
  onboardingStepProgress: "Setup progress",

  // Onboarding step titles (Epic 03)
  onboardingStepCompany: "Set up your company",
  onboardingStepCompanyDesc: "Add your company details",
  onboardingStepWarehouse: "Create a warehouse",
  onboardingStepWarehouseDesc: "Set up inventory locations",
  onboardingStepItems: "Add your first item",
  onboardingStepItemsDesc: "Create products to start selling on your store and ERP",
  onboardingStepPricing: "Set up pricing",
  onboardingStepPricingDesc: "Create a price list",
  onboardingStepCustomers: "Add a customer",
  onboardingStepCustomersDesc: "Create your first customer",

  // Section labels (Epic 03/04)
  applicationsLabel: "Applications",

  // Compact news label (Epic 04)
  latestNews: "Latest News",

  // Transition toast (Epic 05)
  setupComplete: "Setup complete! Your workspace is ready.",

  // Intent paths — onboarding redesign (Plan 40, Epic 03)
  intentPathQuestion: "What would you like to do first?",
  intentPathSelling: "Start selling",
  intentPathSellingDesc: "Add products and start taking orders",
  intentPathChat: "Chat with my customers",
  intentPathChatDesc: "Connect with customers through messaging",
  intentPathContacts: "Organize my contacts",
  intentPathContactsDesc: "Keep track of your customers and leads",
  intentPathExploreAll: "Or explore everything",
  intentPathCompleted: "Path completed!",

  // Intent path step labels
  intentStepAddProduct: "Add your first product",
  intentStepAddProductDesc: "Create a product in your catalog",
  intentStepAddCustomer: "Add a customer",
  intentStepAddCustomerDesc: "Create your first customer record",
  intentStepOpenInbox: "Open your inbox",
  intentStepOpenInboxDesc: "Explore the messaging inbox",
  intentStepAddLead: "Add a lead",
  intentStepAddLeadDesc: "Create your first CRM lead",

  // Discovery prompt (Plan 40, Epic 04)
  discoveryNotNow: "Not now",
  discoverySetUp: "Set up",
  discoveryDismissLabel: "Dismiss this suggestion",

  // Browse Tools page (Plan 40, Epic 04)
  browseToolsTitle: "Browse Tools",
  browseToolsSubtitle: "Explore all the tools available for your business",
  browseToolsActive: "Active",
  browseToolsAvailable: "Available",
  browseToolsComingSoon: "Coming Soon",
  browseToolsSetUp: "Set up",
  browseToolsLearnMore: "Learn more",

  // Tool names and descriptions
  toolProducts: "Products",
  toolProductsDesc: "Manage your product catalog, pricing, and inventory",
  toolOrders: "Orders",
  toolOrdersDesc: "Process sales orders and track deliveries",
  toolCustomers: "Customers",
  toolCustomersDesc: "Keep track of your customer relationships",
  toolCrm: "CRM",
  toolCrmDesc: "Track leads & deals through your sales pipeline",
  toolInbox: "Inbox",
  toolInboxDesc: "Chat with customers through LINE, Facebook, and more",
  toolBuilder: "Storefront Builder",
  toolBuilderDesc: "Design and publish your online store pages",
  toolInsights: "Insights",
  toolInsightsDesc: "Understand your business with visual dashboards",
  toolSeo: "SEO",
  toolSeoDesc: "See how customers find your store on Google",
  toolAffine: "Notes",
  toolAffineDesc: "Organize your ideas and knowledge base",
  toolMail: "Mail",
  toolMailDesc: "Send and receive business email",

  // Chatwoot pulse tile labels
  chatwootOpenConversations: "Open Conversations",
  chatwootUnassigned: "Unassigned conversations",

  // Usage & Plan card (Plan 86, Epic 03)
  usagePlanTitle: "Plan & Usage",
  usageThisMonth: "this month",
  usageUsers: "users",
  usageOfUnlimitedUsers: "of unlimited users",
  usageUser: "user",
  usageStorage: "storage",
  usageNoFilesYet: "No files yet",
  usageGbIncluded: "GB included",
  usageStorefront: "storefront",
  usageStorefronts: "storefronts",
  usageStorefrontIncluded: "storefront (included)",
  usageAppsActive: "apps active",
  usageNoAppsInstalled: "No apps installed",
  usageBrowseAppStore: "Browse App Store",
  usageIncluded: "included",
  usageEstimatedTotal: "Estimated total",
  usagePerMonth: "/mo",
  usageViewDetails: "View details",

  // Usage Detail Page (Plan 86, Epic 04)
  usagePageTitle: "Usage & Billing",
  usagePlanSummaryTitle: "Your Plan",
  usagePlanName: "Zaviago Business Platform",
  usagePlanPricePerUser: "per user/month",
  usagePlanIncludes: "Includes",
  usagePlanUnlimitedUsers: "Unlimited users",
  usagePlanStorefrontsIncluded: "storefront",
  usagePlanStorageIncludedLabel: "GB storage",
  usagePlanBuilder: "Builder (page editor)",
  usagePlanAddOns: "Add-ons",
  usagePlanExtraStorefront: "Additional storefronts",
  usagePlanStorageOverage: "Storage overage",
  usagePlanPerStoreMonth: "/store/month",
  usagePlanPerGbMonth: "/GB/month",
  usageBreakdownTitle: "Current Usage",
  usageLastUpdated: "Last updated",
  usageDataOutdated: "(data may be outdated)",
  usageUsersNoLimit: "No limit. Each user costs",
  usageUsersPerMonth: "/month",
  usageStorageIncludedNote: "included in your plan. Overage at",
  usageStorefrontIncludedNote: "storefront included. Additional at",
  usageActiveAppsTitle: "Active Apps",
  usageActiveSince: "Active since",
  usageAppPricingNote: "Pricing for apps will be announced soon.",
  usageNoAppsDetail: "No apps installed yet. Apps extend your platform with CRM, Chat, Analytics, and more.",
  usageCostEstimateTitle: "Estimated Monthly Cost",
  usageCostUsers: "users",
  usageCostStorage: "Storage",
  usageCostStorefront: "storefront",
  usageCostApps: "Apps",
  usageCostTotal: "Estimated total",
  usageCostDisclaimer: "This is an estimate. Actual billing will begin when payment integration is available.",
  usageCostLearnMore: "Learn more",
  usageEach: "each",

  // Business Dashboard (Plan 1921)
  businessDashboardTitle: "Business Dashboard",
  businessDashboardSubtitle: "Performance overview",
  businessDashboardCustomize: "Customize",
  businessDashboardDone: "Done",
  businessDashboardAddWidget: "Add Widget",
  businessDashboardReset: "Reset",

  // Resource meters (Plan 91, Epic 02)
  usageResourceUnlimited: "Unlimited",
  usageResourceIncluded: "included",
  usageResourcePerMonth: "this month",
  usageResourcePerDay: "today",
  usageResourceAndMore: "more…",
} as const;
